import { ReactNode } from "react";
import styled from "styled-components";
import {
  colors,
  LinkNext,
  Image,
  ButtonProps,
  Button,
} from "@literati/public-ui-shared-react";
import { LINKS } from "globalConfig";
import { makeQueryString } from "@literati/kids-api";
import analytics from "analytics";

const HeaderText = styled.h2`
  font-family: hoefler;
  font-style: normal;
  font-weight: 700;
  font-size: 2rem;
  text-align: center;
  max-width: 450px;
  color: ${colors.inkBlack};
  margin: auto;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.p`
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  max-width: 450px;
  margin: 1rem auto;
  color: ${colors.warmGray4};
  text-align: center;
`;

const ImageContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const imageProps = {
  alt: "Illustration of a stack of books with stars around them.",
  src: "https://images.ctfassets.net/vqtz4cq2w5ts/ZSp50c6a8J3KinQK5B44c/c1d846d466856f847c646f081c584012/Books_Wrapped.png",
  height: 117,
  width: 205,
};

const CTA_LABEL = "Complete Your Reader Profile";

type SharedProps = {
  ctaLabel?: ReactNode;
  subscriptionId: number;
};

export type PersonalizationCTAProps =
  | (SharedProps & {
      variant: "link";
      href?: string;
    })
  | (SharedProps & {
      variant: "button";
      buttonProps: ButtonProps;
    });

export const PersonalizationCTA = (props: PersonalizationCTAProps) => {
  const { ctaLabel, subscriptionId, variant } = props;

  return (
    <Container>
      <ImageContainer>
        <Image {...imageProps} alt="" />
      </ImageContainer>

      <HeaderText>Now, let’s personalize!</HeaderText>
      <Content>
        Your input helps us to create an experience as unique as your reader.
        We’ll learn from your feedback and refine each box as we go!
      </Content>
      {variant === "link" ? (
        <LinkNext
          buttonVariantStyle="primary"
          css="margin: 1rem auto"
          href={
            props.href || LINKS.shuffle + makeQueryString({ subscriptionId })
          }
          legacyBehavior={false}
          variant="button"
          onClick={() => analytics.trackAmplitudeClickEvent(CTA_LABEL)}
        >
          {ctaLabel || CTA_LABEL}
        </LinkNext>
      ) : null}
      {variant === "button" ? (
        <Button css="margin: 1rem auto" {...props.buttonProps} />
      ) : null}
    </Container>
  );
};
